// ============================================================================
// CHINESE (SIMPLIFIED) TRANSLATIONS - JESUS IS NOT
// ============================================================================
// 澄清耶稣是谁（以及祂不是谁）

export const jesusIsNot = [
  {
    category: "爱",
    text: "耶稣不是种族主义者 - 祂平等地爱所有人，不论其出身",
    reference: "约翰福音4:9 - 撒玛利亚妇人惊讶耶稣与她说话",
    context: "耶稣打破了祂那个时代的文化和种族障碍"
  },
  {
    category: "排斥",
    text: "耶稣不排斥他人 - 祂接纳所有人，尤其是被边缘化的人",
    reference: "马太福音9:10-13 - 耶稣与税吏和罪人同席",
    context: "耶稣寻找被社会遗弃和拒绝的人"
  },
  {
    category: "审判",
    text: "耶稣不定罪 - 祂来是为了拯救，而不是定罪",
    reference: "约翰福音3:17 - 神差祂的儿子降世，不是要定世人的罪",
    context: "耶稣的使命是救赎和恢复"
  },
  {
    category: "暴力",
    text: "耶稣不暴力 - 祂教导爱仇敌",
    reference: "马太福音5:44 - 要爱你们的仇敌",
    context: "耶稣以激进的爱革新了正义的概念"
  },
  {
    category: "财富",
    text: "耶稣不是物质主义者 - 祂警告人不要爱钱财",
    reference: "马太福音6:24 - 你们不能又事奉神，又事奉玛门",
    context: "耶稣看重天上的财宝胜过地上的"
  },
  {
    category: "骄傲",
    text: "耶稣不骄傲 - 祂谦卑自己并服事人",
    reference: "约翰福音13:5 - 耶稣为门徒洗脚",
    context: "耶稣显示伟大在于谦卑的服事"
  },
  {
    category: "律法主义",
    text: "耶稣不是律法主义者 - 祂把怜悯置于仪式之上",
    reference: "马太福音12:7 - 我喜爱怜恤，不喜爱祭祀",
    context: "耶稣批评忘记律法核心的律法主义"
  },
  {
    category: "性别",
    text: "耶稣不是性别歧视者 - 祂尊重和重视女性",
    reference: "约翰福音4:27 - 门徒惊讶祂与妇人说话",
    context: "耶稣挑战祂文化中的父权规范"
  },
  {
    category: "权力",
    text: "耶稣不是暴君 - 祂以爱和榜样领导",
    reference: "马太福音20:28 - 人子来，不是要受人的服事，乃是要服事人",
    context: "耶稣重新定义领导为牺牲的服事"
  },
  {
    category: "报复",
    text: "耶稣不报复 - 祂饶恕和恢复",
    reference: "路加福音23:34 - 父啊，赦免他们！因为他们所做的，他们不晓得",
    context: "耶稣甚至在十字架上实践激进的饶恕"
  },
  {
    category: "冷漠",
    text: "耶稣不冷漠 - 祂对受苦的人充满同情",
    reference: "马太福音9:36 - 祂怜悯他们",
    context: "耶稣对受苦者表现出深切的同情"
  },
  {
    category: "精英",
    text: "耶稣不是精英主义者 - 祂与普通人为伴",
    reference: "马可福音1:16-20 - 耶稣呼召渔夫作门徒",
    context: "耶稣拣选普通人完成祂非凡的使命"
  },
  {
    category: "虚伪",
    text: "耶稣不虚伪 - 祂活出祂所教导的",
    reference: "约翰福音8:46 - 你们中间谁能指证我有罪呢？",
    context: "耶稣挑战人找出祂言行之间的矛盾"
  },
  {
    category: "僵化",
    text: "耶稣不僵化 - 祂根据每个人调整教导",
    reference: "约翰福音3 - 耶稣对尼哥底母和撒玛利亚妇人说话方式不同",
    context: "耶稣根据每个人的需要个性化祂的信息"
  },
  {
    category: "传统",
    text: "耶稣不是盲目的传统主义者 - 祂质疑压迫性的传统",
    reference: "马可福音7:13 - 你们承接遗传，废了神的道",
    context: "耶稣重视律法的精神胜过人的传统"
  },
  {
    category: "民族主义",
    text: "耶稣不是民族主义者 - 祂的国度超越国界",
    reference: "马太福音28:19 - 去使万民作我的门徒",
    context: "耶稣的使命是普世的，不限于一个民族"
  },
  {
    category: "分裂",
    text: "耶稣不制造分裂 - 祂为信徒的合一祷告",
    reference: "约翰福音17:21 - 使他们都合而为一",
    context: "让我们庆祝多样性，而不是制造言语战争"
  },
  {
    category: "真理",
    text: "耶稣不说谎 - 祂揭露谎言和操纵",
    reference: "约翰福音8:44 - 魔鬼是说谎之人的父",
    context: "耶稣揭露伤害灵魂的谎言和操纵"
  },
  {
    category: "慷慨",
    text: "耶稣不吝啬 - 祂的慷慨远超十一奉献",
    reference: "路加福音21:3 - 这穷寡妇所投的比众人还多",
    context: "耶稣的慷慨比十一奉献的义务更强"
  },
  {
    category: "正义",
    text: "耶稣不是沉默的同谋 - 祂以健全的正义保护",
    reference: "马太福音18:6 - 凡使这信我的一个小子跌倒的",
    context: "掩盖过错而不保护他人的沉默不是耶稣的智慧"
  }
];

export default jesusIsNot;
